export class Data {

    static post = (url, objet) => {
        const json = {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "ApiKey": sessionStorage.getItem("idContact") /* 20241002 : YD */
            },
            body: JSON.stringify(objet)
        };
        return fetch(url, json).then(response => response.json());
    };

    /* ----- */

    static _logIn = (login, password, accessKey) => {
        const objet = { login, password, accessKey };
        const url = "api/Contact/LogIn";
        return Data.post(url, objet);
    };

    static _logOut = () => {
        const objet = {};
        const url = "api/Contact/LogOut";
        return Data.post(url, objet);
    };

    static _updatePasswordOffline = (resetKey, newPassword, newPasswordConfirmation) => {
        const objet = { resetKey, newPassword, newPasswordConfirmation };
        const url = "api/Contact/UpdatePasswordOffline";
        return Data.post(url, objet);
    };

    static _updatePasswordOnline = (currentPassword, newPassword, newPasswordConfirmation) => {
        const objet = { currentPassword, newPassword, newPasswordConfirmation };
        const url = "api/Contact/UpdatePasswordOnline";
        return Data.post(url, objet);
    };

    static _resetPassword = (login) => {
        const objet = { login };
        const url = "api/Contact/ResetPassword";
        return Data.post(url, objet);
    };

    static _updateProfile = (contact) => {
        const url = "api/Contact/UpdateProfile";
        return Data.post(url, contact);
    };

    static _checkEmail = (email) => {
        const objet = { email };
        const url = "api/Contact/CheckEmail";
        return Data.post(url, objet);
    };

    static _markDocumentAsRead = (rowGUID) => {
        const objet = { rowGUID };
        const url = "api/Document/MarkAsRead";
        return Data.post(url, objet);
    };

    static _markAllMessageAsRead = () => {
        const objet = {};
        const url = "api/Message/MarkAllAsRead";
        return Data.post(url, objet);
    };

    static _getUrlTchatHub = () => {
        const objet = {};
        const url = "api/Tchat/GetUrlTchatHub";
        return Data.post(url, objet);
    };

    /* ----- */

    static _getActualites = (idOperation) => {
        const objet = { idOperation };
        const url = "api/Actualite/Lister";
        return Data.post(url, objet);
    };

    static _getDocuments = (idOperation, idLotCommercial) => {
        const objet = { idOperation, idLotCommercial };
        const url = "api/Document/Lister";
        return Data.post(url, objet);
    };

    static _getFileData = (rowGUID) => {
        const objet = { rowGUID };
        const url = "api/Document/GetFileData";
        return Data.post(url, objet);
    };

    static _getIntervenants = (idOperation, idLotCommercial) => {
        const objet = { idOperation, idLotCommercial };
        const url = "api/Intervenant/Lister";
        return Data.post(url, objet);
    };

    static _getLotsCommerciaux = () => {
        const objet = {};
        const url = "api/LotCommercial/Lister";
        return Data.post(url, objet);
    };

    static _getLots = (idOperation, idLotCommercial) => {
        const objet = { idOperation, idLotCommercial };
        const url = "api/Lot/Lister";
        return Data.post(url, objet);
    };

    static _getMessages = () => {
        const objet = {};
        const url = "api/Message/Lister";
        return Data.post(url, objet);
    };

    static _getReglements = (idOperation, idLotCommercial) => {
        const objet = { idOperation, idLotCommercial };
        const url = "api/Reglement/Lister";
        return Data.post(url, objet);
    };

    static _getStades = (idOperation, idLotCommercial) => {
        const objet = { idOperation, idLotCommercial };
        const url = "api/Reservation_Echeancier_Stade/Lister";
        return Data.post(url, objet);
    };

};